import { SVGIcon } from '@superops/super-icons';
import { Button, Card, TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';

function ChangeSession({ changeSession }) {
  return (
    <div className="position-absolute full-width min-height-200 bottom0">
      <Card rounded AdaptHeight>
        <div className="flex-center fcol min-height-200">
          <SVGIcon name="ChannelSwitch" size="xxl" />
          <div className="mbt5">
            <Button plain onClick={changeSession}>
              <TextStyle weight="Medium">
                <FormattedMessage id="msp.chat.channel.switch.message" />
              </TextStyle>
            </Button>
          </div>
          <TextStyle variation="subdued">
            <div className="flex-center wrap tcenter mlr-30">
              <FormattedMessage id="msp.chat.channel.switch.message.description" />
            </div>
          </TextStyle>
        </div>
      </Card>
    </div>
  );
}
export default ChangeSession;
